<template>
  <div v-if="adBanners.length > 0" ref="adSection" class="ad-section">
    <swiper :modules="[Navigation, Pagination, Autoplay]" navigation pagination loop
      :autoplay="{ delay: 7000, disableOnInteraction: false }" class="ad-swiper" @slideChange="onSlideChange"
      @swiper="onSwiperReady">
      <swiper-slide v-for="(ad, index) in adBanners" :key="index" class="ad-slide">
        <img :src="ad.img" :alt="ad.title || `광고 ${index + 1}`" class="ad-image" style="cursor: pointer"
          @click="handleAdClick(ad)" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import { Navigation, Pagination, Autoplay } from "swiper";
import { incrementBannerImpressionCount } from "@/utils/write/banner";

export default {
  name: "AdSection",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    adBanners: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      Navigation: Navigation,
      Pagination: Pagination,
      Autoplay: Autoplay,
      observer: null,
      swiperInstance: null,
      impressionRecorded: new Set(), // 이미 노출 기록된 광고 추적
    };
  },
  mounted() {
    this.setupIntersectionObserver();
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    handleAdClick(ad) {
      this.$emit("ad-click", ad);
    },

    onSwiperReady(swiper) {
      this.swiperInstance = swiper;
      // 첫 번째 슬라이드 노출 기록
      if (this.adBanners.length > 0) {
        this.recordImpression(this.adBanners[0]);
      }
    },

    onSlideChange() {
      if (this.swiperInstance && this.adBanners.length > 0) {
        const currentIndex = this.swiperInstance.realIndex;
        const currentAd = this.adBanners[currentIndex];
        if (currentAd) {
          this.recordImpression(currentAd);
        }
      }
    },

    setupIntersectionObserver() {
      // Intersection Observer 설정 - 광고 섹션이 화면에 보이는지 확인
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.5, // 50% 이상 보일 때
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 광고 섹션이 화면에 보이면 현재 표시 중인 광고 노출 기록
            if (this.swiperInstance && this.adBanners.length > 0) {
              const currentIndex = this.swiperInstance.realIndex || 0;
              const currentAd = this.adBanners[currentIndex];
              if (currentAd) {
                this.recordImpression(currentAd);
              }
            }
          }
        });
      }, options);

      // 광고 섹션 관찰 시작
      if (this.$refs.adSection) {
        this.observer.observe(this.$refs.adSection);
      }
    },

    async recordImpression(ad) {
      // 이미 노출 기록된 광고는 중복 기록하지 않음
      const adKey = `${ad.source}-${ad.id}`;
      if (this.impressionRecorded.has(adKey)) {
        return;
      }

      try {
        await incrementBannerImpressionCount(ad);
        this.impressionRecorded.add(adKey);
      } catch (error) {
        console.warn("광고 노출 기록 실패:", error);
        // 노출 기록 실패해도 사용자 경험에는 영향 없음
      }
    },
  },
};
</script>

<style scoped>
/* 광고 섹션 스타일 */
.ad-section {
  overflow: hidden;
}

.ad-swiper {
  border-radius: 8px;
  width: 100%;
  overflow: hidden;
  min-height: 150px;
}

.ad-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
}

.ad-image {
  width: 100%;
  height: auto;
  min-height: 150px;
  object-fit: cover;
  border-radius: 8px;
}

/* 반응형 스타일 */
@media screen and (max-width: 480px) {
  .ad-section {}

  .ad-swiper {
    min-height: 120px;
  }

  .ad-slide {
    min-height: 120px;
  }

  .ad-image {
    min-height: 120px;
    border-radius: 6px;
  }
}
</style>
